module.exports = __webpack_public_path__ + "static/media/exclamation-purple.664d8295.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exclamation-purple.svg
// module id = 2913
// module chunks = 0